export const BackgroundStyle = {
  position: "fixed",
  width: "100vw",
  height: "100vh",
  left: 0,
  right: 0,
}

export const SphereStyle = {
  color: "#00acc7"
}